<template>
  <div class="map">
    <div class="leaflet-container" ref="container"  v-sync="points"></div>
    
    <div class="map-overlay pseudo-search">
      <search :search_index="address_search_index" @search_clicked="search_clicked" />
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import Search from './other/Search';
import "leaflet/dist/leaflet.css";

// import 'leaflet-control-geocoder';
// import "leaflet-control-geocoder/dist/Control.Geocoder.css"
    
// const default_radius = 3;
const selected_radius = 10;


export default {
  name: "points-map",

  components: {
    Search,
  },

  props: {
    points: Array, 
    points_style: Function,
    address_search_index: Array,
  },

  directives: {
    sync: {
      update(el, binding, vnode) {
        let self = vnode.context;
        self.draw(self.points);
      }
    }
  },

  data() {
    return {
      selected_point: null,
      // address_index: null,
    };
  },

  mounted() {
    let self = this;

    this.map = L.map(this.$refs.container, {
      center: [48.8538971, 37.5943581],
      zoom: 13,
      minZoom: 10,
      maxZoom: 18,
      renderer: L.canvas(),
      scrollWheelZoom: false
    });

    if (L.Hash) new L.Hash(this.map);



    // .on('markgeocode', function(e) {
    //   var bbox = e.geocode.bbox;
    //   var poly = L.polygon([
    //     bbox.getSouthEast(),
    //     bbox.getNorthEast(),
    //     bbox.getNorthWest(),
    //     bbox.getSouthWest()
    //   ])
    //   self.map.fitBounds(poly.getBounds());
    // })
    // .addTo(this.map);

    // CartoDB_DarkMatter
    var baselayer = L.tileLayer(
      "http://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        subdomains: "abc"
      }
    );

    baselayer.addTo(this.map);
    this.draw(this.points);

    this.map.on('zoomend', function() {
      var currentZoom = self.map.getZoom();
      self.points_layer.setStyle({radius: level2R(currentZoom)});
    });

    var myIcon = L.icon({
      iconUrl: './marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
    });
    this.selected_marker = L.marker([48.8538971, 37.5943581], {icon: myIcon})

    // this.address_index = this.points.reduce((o,v,i) =>{
    //   let addr = this.address_fn(v);
      
    //   if (!o[addr]) {
    //     o[addr] = [v];
    //   } else {
    //     o[addr].push(v)
    //   }

    //   return o;
    // }, {});
  },

  methods: {
    draw(geojson) {
      console.log("draw points");

      let self = this;

      if (this.points_layer) this.points_layer.clearLayers();

      this.points_layer = L.geoJSON(geojson, {
        style: this.points_style,

        pointToLayer: function(feature, latlng) {
          return L.circleMarker(latlng);
        }
      });

      this.points_layer.setStyle({radius: level2R(this.map.getZoom())})

      this.points_layer.on("click", function(e) {
        var props = e.layer.feature.properties;
        // var active_layer = e.layer;

        // self.selected_layer = e.layer;
        self.selected_point = e.layer.feature
        self.select_layer(e.layer)
      });

      this.points_layer.addTo(this.map);
    },
    
    select_layer(new_layer) {
      let old_layer = this.selected_layer;

      let currentZoom = this.map.getZoom();

      if (old_layer) old_layer.setStyle({radius: level2R(currentZoom)})
      if (new_layer) new_layer.setStyle({radius: selected_radius})

      this.selected_layer = new_layer;
      
      if (this.selected_layer) {
        console.log(this.selected_layer._latlng)
        this.selected_marker.setLatLng(this.selected_layer._latlng)
        this.selected_marker.addTo(this.map)
      } else {
        this.selected_marker.remove()
      }
    },

    select_point(point) {
      let candidate = Object.values(this.points_layer._layers).filter(l => l.feature.properties.idx == point.properties.idx);
      let l = candidate[0]

      this.select_layer(l)
      this.selected_point = l.feature;
    },

    search_clicked(p) {
      let c = p.p.geometry.coordinates
      this.map.setView({lat: c[1], lng: c[0]}, 18, { animation: true });        
    }
  },


  watch: {
    selected_point: function(new_point, old_point) {
      this.$emit('point-selected', this.selected_point)
    },
  }
};

function level2R(level) {
  let max = 9;
  let min = 1;

  let val = Math.pow(level - 10, 1.2);
  return val;
}

</script>

<style lang="scss">

.leaflet-container {
  height: 100%;
  width: 100%;
}

.map-overlay {
  position: absolute;
  top: 1em;
  right: 1em;
  z-index: 10000;

}

.map {
  position: relative;
}



</style>
